<div class="dropdown-container" tabindex="0">
  <div class="dropdown-box"></div>
  <button (click)="toggleDropdown($event)" class="dropdown-button">
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
</div>

<div *ngIf="isOpen" class="dropdown-content">
  <div *ngFor="let group of groups" class="group">
    <ng-container *ngIf="shouldShowGroup(group)">
      <div class="group-header" *ngIf="group[groupItemsProp].length > 0">
        <button *ngIf="!group.expanded" color="primary" class="expand-button" (click)="toggleGroup($event, group)"
          mat-raised-button>+</button>
        <button *ngIf="group.expanded" color="accent" class="expand-button" (click)="toggleGroup($event, group)"
          mat-raised-button>-</button>
        <span class="label">{{ group[groupDisplayProp] }}</span>
        <button *ngIf="!hideGroupSelection" color="primary" mat-mini-fab (click)="selectGroup($event, group)" class="add-button" [disabled]="disabled">+</button>
      </div>
      <div *ngIf="group.expanded" class="instruments-list">
        <div *ngFor="let item of group[groupItemsProp]" class="item-header">
          <ng-container *ngIf="shouldShowItem(item)">
            <span class="label">{{ item[itemDisplayProp] }}</span>
            <button color="primary" mat-mini-fab (click)="selectItem($event, item)" [disabled]="disabled" class="add-button">+</button>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>